import { render, staticRenderFns } from "./socials.vue?vue&type=template&id=47c2ae49&scoped=true&"
import script from "./socials.vue?vue&type=script&lang=ts&setup=true&"
export * from "./socials.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./socials.vue?vue&type=style&index=0&id=47c2ae49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c2ae49",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47c2ae49')) {
      api.createRecord('47c2ae49', component.options)
    } else {
      api.reload('47c2ae49', component.options)
    }
    module.hot.accept("./socials.vue?vue&type=template&id=47c2ae49&scoped=true&", function () {
      api.rerender('47c2ae49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/info/socials.vue"
export default component.exports